<template>
  <div>
    <ContentHeader title="Dashboard" />
    <dashboard-skeleton v-if="loading"></dashboard-skeleton>
    <section v-else class="content">
      <div class="container-fluid">
        <div class="row">
          <router-link
            :to="{ name: 'RobotList' }"
            class="col-lg-4 col-md-6 col-sm-12 text-dark pb-4"
          >
            <div class="card card-icon px-4 py-3 shadow h-100">
              <div class="counter-container">
                <h5>Total Robot</h5>

                <h1>{{ robotTotal }}</h1>
              </div>
              <div class="icon-container">
                <i class="fas fa-robot bg-info"></i>
              </div>
            </div>
          </router-link>
          <!-- ./col -->
          <router-link
            to="/subscription/?data=INSTALLED"
            class="col-lg-4 col-md-6 col-sm-12 text-dark pb-4"
          >
            <div class="card card-icon px-4 py-3 shadow h-100">
              <div class="counter-container">
                <h5>Investor</h5>

                <h1>{{ investorAmmount }}</h1>
              </div>
              <div class="icon-container">
                <i class="fas fa-user bg-success"></i>
              </div>
            </div>
          </router-link>
          <!-- ./col -->
          <router-link
            :to="{ name: 'Disbursement' }"
            class="col-lg-4 col-md-6 col-sm-12 text-dark pb-4"
          >
            <div class="card card-icon px-4 py-3 shadow h-100">
              <div class="counter-container">
                <h5>Deposit Total</h5>

                <h1 class="ammount-overflow">
                  {{ depositTotal }}
                </h1>
              </div>
              <div class="icon-container">
                <i class="fas fa-money-bill bg-danger"></i>
              </div>
            </div>
          </router-link>
          <!-- ./col -->
        </div>
        <div class="row">
          <section class="col-lg-12 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-chart-line mr-1"></i>
                  Subscription
                </h3>
              </div>
              <div class="card-body">
                <div class="tab-content p-0">
                  <line-chart
                    :data="datasets"
                    :colors="['#ffc107', '#28a745', '#dc3545']"
                  ></line-chart>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import DashboardSkeleton from "@/components/loading-screen/DashboardSkeleton.vue";
import moment from "moment";
import apiClient from "../services/ApiServices";
import apiVendor from "../services/VendorApiServices";

export default {
  name: "Dashboard",

  data() {
    return {
      loading: true,
      robotTotal: 0,
      depositTotal: 0,
      subscriptions: [],
    };
  },
  components: {
    ContentHeader,
    DashboardSkeleton,
  },
  computed: {
    datasets: computedDatasets,
    investorAmmount: function () {
      return this.subscriptions.filter(
        (item, index, array) =>
          array.findIndex(
            (data) =>
              data.investor_name === item.investor_name &&
              data.installation_status === "INSTALLED"
          ) === index
      ).length;
    },
  },
  async mounted() {
    try {
      let robot = await apiClient.get(`?vendor_id=${this.$user_id}&without_broker=true`);
      this.robotTotal = robot.data.data.length;

      let disbursement = await apiVendor.get(`${this.$user_id}/disbursement/`);
      disbursement.data.data.forEach((element) => {
        this.depositTotal += element.transaction.deposit_amount;
      });

      const subResponse = await apiVendor.get(`${this.$user_id}/subscriptions`)
      if(subResponse.data?.data){
        this.subscriptions = subResponse.data?.data
      }

    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.response.data.data.massage,
        "error"
      );
    } finally {
      this.loading = false;
      this.depositTotal = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(this.depositTotal);
    }
  },
};

function computedDatasets() {
  return [
    {
      name: "Subscription Pending",
      data: populate(subscriptionFiltering(this.subscriptions, "PENDING")),
    },
    {
      name: "Subscription Installed",
      data: populate(subscriptionFiltering(this.subscriptions, "INSTALLED")),
    },
    {
      name: "Subscription Expired",
      data: populate(subscriptionFiltering(this.subscriptions, "EXPIRED")),
    },
  ];
}

function subscriptionFiltering(records, status) {
  return records.filter((item) => item.installation_status == status);
}

function populate(records) {
  let months = new Array(12)
    .fill(0)
    .reduce((accumulated, currentValue, currentIndex) => {
      let objectTanggal = new Date(2021, currentIndex, 1);
      let monthName = moment(objectTanggal).format("MMMM").toLowerCase();
      accumulated[monthName] = 0;
      return accumulated;
    }, {});

  return records.reduce((accumulated, curr) => {
    let monthName = moment(curr.created_at).format("MMMM").toLowerCase();
    accumulated[monthName] += 1;
    return accumulated;
  }, months);
}
</script>

<style>
@media only screen and (min-width: 976px) {
  .ammount-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ammount-overflow:hover {
    overflow: scroll;
    text-overflow: unset;
  }
}

@media only screen and (max-width: 601px) {
  .inner > div {
    width: 100% !important;
  }
}
.card-icon {
  display: flex;
  justify-content: space-between !important;
  flex-direction: row !important;
  border: none !important;
  border-radius: 10px !important;
}
.card-icon h1 {
  font-size: calc(12px + (54 - 24) * ((100vw - 300px) / (1600 - 300)));
}
.counter-container {
  width: 75%;
}
.icon-container {
  width: 25%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.icon-container > i {
  color: #ffffff;
  font-size: 30px;
  border-radius: 10px;
  padding: 0.75rem;
}
</style>